export const DO_NOT_SHOW_AGAIN_KEY = 'VideoEditor.doNotShowAddToBrandOverlay';
